export default __webpack_public_path__ + "a451670abd13562eeea72c4ae076e685.png";